<template>
    <modal-side-filters
    :triggerClose="triggerClose"
    :showButtons="showFooterHandler"
    @clearFilters="clearFilters"
    @hideMe="[emit('hideMe'), triggerClose = false]"
    @applyFilters="applyFiltersHandler">
        <div class="filters-container">
			<!-- Double Calendar -->
			<input-double-calendar
			:fromDateParams="{ ...beginDateParams, inputValue: modalFilters.beginDate }"
			:toDateParams="{ ...endDateParams, inputValue: modalFilters.endDate }"
			@inputFromDate="modalFilters.beginDate = $event"
			@inputToDate="modalFilters.endDate = $event"/>
            <!-- Status Dropdown -->
            <dropdown-generic
            :params="statusDropdownParams"
            :options="statusDropdownOptions"
            :selectedOption="modalFilters.status"
            @clicked="modalFilters.status = $event"/>
        </div>
    </modal-side-filters>
</template>

<script setup>
import ModalSideFilters from '@/components/generic/modals/side/Filters'
import InputDoubleCalendar from '@/components/generic/inputs/DoubleCalendar'
import DropdownGeneric from '@/components/generic/dropdowns/generic/Generic'
/* Vue */
import { ref, computed } from 'vue'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe', 'applyFilters'])

/* Props
@appliedFilters { Object } - object with filters
@statusList { Object }
@beginDateParams { Object } - object with params used in view, we will use it here so if changes are needed we only need to do them in one place
@endDateParams { Object } - object with params used in view, we will use it here so if changes are needed we only need to do them in one place
*/
const props = defineProps({
    appliedFilters: Object,
    statusList: Object,
	beginDateParams: Object,
	endDateParams: Object
})

const triggerClose = ref(false)

const modalFilters = ref({
	beginDate: props.appliedFilters.beginDate,
	endDate: props.appliedFilters.endDate,
    status: props.appliedFilters.status
})

const statusDropdownParams = ref({
	labelText: t('transfers.history.international.filters.status'),
	mobileTitle: t('transfers.history.international.filters.status'),
	placeholder: t('transfers.history.international.placeholders.status')
})

const statusDropdownOptions = computed(() => {
    return props.statusList.map(status => ({
        id: status.id,
        text: status.description
    }))
})

/* To show or hide the filter modal footer */
const showFooterHandler = computed(() => {
    const { beginDate, endDate, status } = modalFilters.value

    const emptyFields = Object.values(modalFilters.value).every(field => field === null || field === '')
    const hasAppliedFilters = Object.values(props.appliedFilters).some(filter => filter && filter !== '')
    const filtersChanged = (beginDate !== props.appliedFilters.beginDate &&
                            endDate !== props.appliedFilters.endDate &&
                            status !== props.appliedFilters.status)
    return !emptyFields || hasAppliedFilters || filtersChanged
})

/* Clearing filters */
const clearFilters = () => {
    for (const filter in modalFilters.value) {
        modalFilters.value[filter] = null
    }
}

const applyFiltersHandler = () => {
    triggerClose.value = true
    emit('applyFilters', { ...props.appliedFilters, ...modalFilters.value })
}
</script>

<style lang="scss" scoped>
.filters-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
}
</style>
